<template>
	<div class="sidebar">
		<div class="sidebar__title">Выбор игры</div>
		<div class="sidebar__items">
			<router-link class="sidebar__item" :to="{name: 'dice'}" :class="[page === 'dice' ? 'active' : '']">
				<svg class="sidebar__item-logo"><use href="#svg-icon-dice"></use></svg>
				<span class="sidebar__item-text">Dice</span>
			</router-link>
			<router-link class="sidebar__item" :to="{name: 'mines'}" :class="[page === 'mines' ? 'active' : '']">
				<svg class="sidebar__item-logo"><use href="#svg-icon-mines"></use></svg>
				<span class="sidebar__item-text">Mines</span>
			</router-link>
			<router-link class="sidebar__item" :to="{name: 'slots'}" :class="[page === 'slots' || page === 'slotsGame' ? 'active' : '']">
				<svg class="sidebar__item-logo"><use href="#svg-icon-slots"></use></svg>
				<span class="sidebar__item-text">Slots</span>
			</router-link>
			<router-link class="sidebar__item" :to="{name: 'live'}" :class="[page === 'live' ? 'active' : '']">
				<svg class="sidebar__item-logo"><use href="#svg-icon-live"></use></svg>
				<span class="sidebar__item-text">Live</span>
			</router-link>
			<router-link class="sidebar__item" :to="{name: 'coinflip'}" :class="[page === 'coinflip' ? 'active' : '']">
				<svg class="sidebar__item-logo"><use href="#svg-icon-coin"></use></svg>
				<span class="sidebar__item-text">Coin</span>
			</router-link>
			<router-link class="sidebar__item disabled" :to="{name: 'coinflip'}" :disabled="true" :class="[page === 'wheel' ? 'active' : '']">
				<svg class="sidebar__item-logo"><use href="#svg-icon-wheel"></use></svg>
				<span class="sidebar__item-text">Wheel</span>
			</router-link>
		</div>
	</div>
</template>

<script>
    export default {

		computed: {
			page() {
				return this.$route.name
			}
		}
    }
</script>